import { createApi } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'api/client';
import { axiosBaseQuery } from 'helper/axios/axiosBaseQuery';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL,
  }),
  tagTypes: [
    'user',
    'religion',
    'maritalStatus',
    'designation',
    'department',
    'area',
    'branch',
    'employee',
    'course',
    'education',
    'experience',
    'training',
    'salary',
    'transfer',
    'attendanceSetting',
    'attendance',
    'device',
    'letterType',
    'letter',
    'leaveType',
    'leave',
    'holiday',
    'itemType',
    'vehicleType',
    'conveyance',
    'item',
    'shop',
    'uom',
    'bill',
    'productBrand',
    'product',
    'quotation',
    'mobile',
    'mobileUser',
    'mobileBill',
    'monthSalary',
    'monthSalaryDetail',
  ],
  endpoints: () => ({}),
});
